import React from 'react'
import PropTypes from 'prop-types'

import styles from './Menu.module.scss'

const Menu = props => (
  <main className={styles.menu}>
    {props?.children}
  </main>
)

Menu.propTypes = {
  children: PropTypes.any
}

export default Menu
